var activityEventTemplate, siteVisitEventTemplate, shiftEventTemplate;

$(function () {
    initHandlebars();
});

function initHandlebars() {
    activityEventTemplate = Handlebars.compile($("#activityEventTemplate").html());
    siteVisitEventTemplate = Handlebars.compile($("#siteVisitEventTemplate").html());
    shiftEventTemplate = Handlebars.compile($('#shiftEventTemplate').html());
}

function initResultsView() {
    var filterData = getDataFromFilterControls();

    if (hasQueryParams(filterData)) {
        $('#searchFilters').collapse('show');
    }

    $.ajax({
        url: '/api/Home/CalendarListEvents',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json", // send as JSON
        data: JSON.stringify(filterData),
        success: function (data) {
            var showActivities = ($('#showActivities').length) ? $('#showActivities').is(':checked') : true;
            var showSiteVisits = ($('#showSiteVisits').length) ? $('#showSiteVisits').is(':checked') : false;
            var showShifts = ($('#showShifts').length) ? $('#showShifts').is(':checked') : false;

            var eventList = $('#events-List');
            eventList.empty();

            $.each(data.Events, function (index, value) {
                var template;

                if (value.EventType === 'Activity') {
                    template = activityEventTemplate;
                } else if (value.EventType === 'SiteVisit') {
                    template = siteVisitEventTemplate;
                } else if (value.EventType === 'Shift') {
                    template = shiftEventTemplate;
                }

                var html = template({
                    event: value
                });

                eventList.append(html);
            });
        }
    });
}

function getStartDate(start) {
    return $('#startDateFilter').val();
}

function getEndDate(end) {
    return $('#endDateFilter').val();
}